import type { IconData } from '@stacksjs/iconify-core'

export const ru4x3: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h640v160H0z\"/><path fill=\"#0039a6\" d=\"M0 160h640v160H0z\"/><path fill=\"#d52b1e\" d=\"M0 320h640v160H0z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default ru4x3
